import React from 'react';
import { StarIcon } from 'lucide-react';
import { marqueePhrases } from '../data/partners';
export function Marquee() {
  const items = [...marqueePhrases, ...marqueePhrases];
  return <div className="marquee overflow-hidden bg-catracho py-5" aria-label={marqueePhrases.join('. ')} data-id="element-191" data-mp="2ij4dhoagwfu9">
      <div className="marquee-track flex w-max items-center" aria-hidden="true" data-id="element-192" data-mp="2dl2tn157wchq">
        {[0, 1].map(copy => <div key={copy} className="flex items-center" data-id="element-193" data-mp="3b79ymc5fo6um">
            {items.map((phrase, i) => <span key={`${copy}-${i}`} className="group flex cursor-default items-center" data-id="element-194" data-mp="36a9rrz0rf02g" data-mpi={i}>
                <span className="whitespace-nowrap px-6 font-display text-3xl uppercase text-sand transition-colors duration-150 group-hover:text-sun md:text-4xl" data-id="element-195" data-mp="319dpfpw23lz5">
                  {phrase}
                </span>
                <StarIcon size={22} className="text-sun transition-transform duration-300 ease-out group-hover:rotate-[72deg] group-hover:scale-125" fill="currentColor" strokeWidth={0} data-id="element-196" data-mp="1pvrqxe4b480y" />
              </span>)}
          </div>)}
      </div>
    </div>;
}